import React from 'react';

const NoData = (props) => {
    return <div className="p-2 no-data"><h1 className="text-center">No Data</h1></div>
};
export default NoData;
